import { jsxs, jsx } from "react/jsx-runtime";
import { TooltipRenderer, Box, IconPositive, Text, ButtonIcon, IconBookmark, Link } from "braid-design-system";
import { useJobDetailsViewContext } from "../../CompanyProfile/CompanyProfile.mjs";
import { useMelwaysLink } from "@seek/melways-react";
import { useMemo } from "react";
import { LazyLoadedImg } from "./LazyLoadedImg/LazyLoadedImg.mjs";
import { useTranslations } from "@vocab/react";
import { translations } from "../../../../components/CompetitiveJobs/JobCardLite/SaveJob/SaveJobForSignedIn/.vocab/index.mjs";
import { translations as translations$1 } from "../../../../components/CompetitiveJobs/JobCardLite/SaveJob/SaveJobForSignedOut/.vocab/index.mjs";
import { jobCard, jobCardLink } from "./JobCardLite.css.mjs";
const jobUrlOriginValues = {
  stickyTitle: "stickyTitle",
  jobTitle: "jobTitle",
  showNewTab: "showNewTab",
  competitiveRecommendedJobs: "competitiveRecommendedJobs"
};
const filterJobUrlValues = (values) => {
  const urlValues = {};
  Object.entries(values || {}).forEach(([key, value]) => {
    if (value) {
      urlValues[key] = value;
    }
  });
  return urlValues;
};
const constructFullUrl = ({
  hash = "",
  path,
  query
}) => {
  const queryString = Object.entries(query).map(([key, value]) => `${key}=${value}`).join("&");
  return `${path}${queryString ? `?${queryString}` : ""}${hash ? `#${hash}` : ""}`;
};
const useJobUrl = ({
  id,
  jobUrlOpts,
  renderRelativePaths,
  overrideValues,
  isExpired
}) => {
  const urlResolver = useMelwaysLink();
  return useMemo(() => {
    var _a;
    if (!id) {
      return "about:blank";
    }
    const values = Object.entries(
      (jobUrlOpts == null ? void 0 : jobUrlOpts.params) || {}
    ).reduce((acc, [k, value]) => {
      if (value || value === 0) {
        const key = k;
        if (overrideValues == null ? void 0 : overrideValues[key]) {
          acc[key] = overrideValues[key];
        } else {
          acc[key] = String(value);
        }
      }
      return acc;
    }, {});
    return urlResolver({
      path: constructFullUrl({
        hash: ((_a = jobUrlOpts == null ? void 0 : jobUrlOpts.meta) == null ? void 0 : _a.solMetadataReference) ? `sol=${jobUrlOpts == null ? void 0 : jobUrlOpts.meta.solMetadataReference}` : "",
        path: `/${isExpired ? "expired" : ""}job/${id}`,
        query: filterJobUrlValues(values)
      }),
      product: "candidate",
      absolute: !renderRelativePaths
    });
  }, [
    id,
    urlResolver,
    jobUrlOpts,
    renderRelativePaths,
    overrideValues,
    isExpired
  ]);
};
const JOB_DISPLAY_TYPE_QUERY_KEY = "type";
const JOB_LISTING_POSITION_KEY = "pos";
const JOB_LISTING_NUMBER_OF_SELLING_POINT_KEY = "sp";
const CompanyLogoPlaceholder = ({
  "data-testid": dataTestid
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 31",
    height: "100%",
    fill: "none",
    ...dataTestid ? { "data-testid": dataTestid } : {},
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EAECF1",
          d: "M14.214 2.552V.175H4.707v2.377H2.331v25.26h14.26V2.551h-2.377Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#D2D7DF", d: "M25.464 7.308h-8.873v20.505h8.873V7.308Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#EAECF1",
          d: "M21.919 12.06h-1.783a.297.297 0 0 0-.297.297v1.783c0 .164.133.297.297.297h1.783a.297.297 0 0 0 .297-.297v-1.783a.297.297 0 0 0-.297-.297Zm0 4.752h-1.783a.297.297 0 0 0-.297.297v1.783c0 .164.133.297.297.297h1.783a.297.297 0 0 0 .297-.297v-1.783a.297.297 0 0 0-.297-.297Zm-2.079 4.755h2.376v2.08a.297.297 0 0 1-.297.297h-2.08v-2.377Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#D2D7DF",
          d: "M7.975 7.308H6.193a.297.297 0 0 0-.297.297v1.782c0 .164.133.297.297.297h1.782a.297.297 0 0 0 .297-.297V7.605a.297.297 0 0 0-.297-.298Zm0 4.752H6.193a.297.297 0 0 0-.297.297v1.783c0 .164.133.297.297.297h1.782a.297.297 0 0 0 .297-.297v-1.783a.297.297 0 0 0-.297-.297Zm0 4.752H6.193a.297.297 0 0 0-.297.297v1.783c0 .164.133.297.297.297h1.782a.297.297 0 0 0 .297-.297v-1.783a.297.297 0 0 0-.297-.297Zm4.754-9.504h-1.783a.297.297 0 0 0-.297.297v1.782c0 .164.133.297.297.297h1.783a.297.297 0 0 0 .297-.297V7.605a.297.297 0 0 0-.297-.298Zm0 4.752h-1.783a.297.297 0 0 0-.297.297v1.783c0 .164.133.297.297.297h1.783a.297.297 0 0 0 .297-.297v-1.783a.297.297 0 0 0-.297-.297Zm0 4.752h-1.783a.297.297 0 0 0-.297.297v1.783c0 .164.133.297.297.297h1.783a.297.297 0 0 0 .297-.297v-1.783a.297.297 0 0 0-.297-.297Zm-4.754 4.755H6.193a.297.297 0 0 0-.297.297v1.783c0 .164.133.297.297.297h1.782a.297.297 0 0 0 .297-.297v-1.783a.297.297 0 0 0-.297-.297Zm4.754 0h-1.783a.297.297 0 0 0-.297.297v1.783c0 .164.133.297.297.297h1.783a.297.297 0 0 0 .297-.297v-1.783a.297.297 0 0 0-.297-.297Zm14.241 6.245H.825v2.5h26.143v-2.5Z"
        }
      )
    ]
  }
);
const SavedJobForApplied = ({ id }) => {
  const { t } = useTranslations(translations);
  const title = t("You have applied for this job");
  return /* @__PURE__ */ jsx(TooltipRenderer, { id: `serp_applied_${id}`, tooltip: /* @__PURE__ */ jsx(Text, { children: title }), children: ({ triggerProps }) => /* @__PURE__ */ jsx(
    Box,
    {
      ...triggerProps,
      data: {
        testid: "applied-job-icon",
        automation: "applied-job"
      },
      children: /* @__PURE__ */ jsx(IconPositive, { tone: "positive" })
    }
  ) });
};
const SaveJobButton = ({ id, isSaved, toggleSavedJob }) => {
  const { t } = useTranslations(translations);
  const buttonText = isSaved ? t("Unsave") : t("Save");
  return /* @__PURE__ */ jsx(
    ButtonIcon,
    {
      id: `serp-save-job-${id}`,
      label: buttonText,
      variant: "transparent",
      data: {
        testid: isSaved ? "remove-save-job" : "save-job",
        automation: isSaved ? "remove-saved-job" : "save-job"
      },
      icon: /* @__PURE__ */ jsx(
        IconBookmark,
        {
          tone: isSaved ? "brandAccent" : void 0,
          active: isSaved
        }
      ),
      onClick: (e) => {
        e.stopPropagation();
        toggleSavedJob(e);
      }
    }
  );
};
const SaveJobForSignedIn = ({
  isApplied,
  id,
  isSaved,
  toggleSavedJob
}) => isApplied ? /* @__PURE__ */ jsx(SavedJobForApplied, { id }) : /* @__PURE__ */ jsx(SaveJobButton, { id, isSaved, toggleSavedJob });
const SaveJobForSignedOut = ({
  id,
  toggleSavedJob
}) => {
  const { t } = useTranslations(translations$1);
  return /* @__PURE__ */ jsx(
    ButtonIcon,
    {
      id: `serp-signed-out-save-job-${id}`,
      label: t("Sign in to save this job"),
      variant: "transparent",
      data: {
        testid: "signed-out-save-job",
        automation: "signed-out-save-job"
      },
      icon: /* @__PURE__ */ jsx(IconBookmark, {}),
      onClick: toggleSavedJob
    }
  );
};
const SaveJob = ({
  isLoggedIn,
  id,
  toggleSavedJob,
  isApplied,
  isSaved
}) => isLoggedIn ? /* @__PURE__ */ jsx(
  SaveJobForSignedIn,
  {
    id,
    toggleSavedJob,
    isApplied,
    isSaved
  }
) : /* @__PURE__ */ jsx(SaveJobForSignedOut, { id, toggleSavedJob });
const CARD_PADDING = "medium";
const JobCardLiteView = ({
  id,
  title,
  advertiserName,
  locationLabel,
  listingDateLabel,
  srcLogo,
  jobUrl,
  saveJob,
  isLoggedIn,
  openInNewTab
}) => /* @__PURE__ */ jsxs(
  Box,
  {
    padding: CARD_PADDING,
    borderRadius: "large",
    cursor: "pointer",
    position: "relative",
    width: "full",
    className: jobCard,
    children: [
      /* @__PURE__ */ jsx(
        Link,
        {
          href: jobUrl,
          className: jobCardLink,
          target: openInNewTab ? "_blank" : "_self"
        }
      ),
      /* @__PURE__ */ jsx(Box, { style: { height: "48px" }, display: "flex", alignItems: "center", children: srcLogo ? /* @__PURE__ */ jsx(LazyLoadedImg, { src: srcLogo, id: `${id}-company-logo-container` }) : /* @__PURE__ */ jsx(Box, { style: { height: "40px" }, children: /* @__PURE__ */ jsx(CompanyLogoPlaceholder, { "data-testid": "companyLogo-placeholder" }) }) }),
      /* @__PURE__ */ jsx(Box, { paddingTop: "small", children: /* @__PURE__ */ jsx(Text, { size: "standard", weight: "medium", maxLines: 1, children: title }) }),
      /* @__PURE__ */ jsx(Box, { paddingTop: "xsmall", children: /* @__PURE__ */ jsx(Text, { maxLines: 1, children: advertiserName }) }),
      /* @__PURE__ */ jsx(Box, { paddingTop: "small", children: /* @__PURE__ */ jsx(Text, { maxLines: 1, size: "small", children: locationLabel }) }),
      /* @__PURE__ */ jsx(Box, { paddingTop: "medium", children: /* @__PURE__ */ jsx(Text, { tone: "secondary", maxLines: 1, size: "small", children: listingDateLabel }) }),
      /* @__PURE__ */ jsx(
        Box,
        {
          position: "absolute",
          right: 0,
          top: 0,
          paddingRight: CARD_PADDING,
          paddingTop: CARD_PADDING,
          children: /* @__PURE__ */ jsx(
            SaveJob,
            {
              id,
              isLoggedIn: isLoggedIn || false,
              isApplied: saveJob.isApplied,
              isSaved: saveJob.isSaved,
              toggleSavedJob: saveJob.toggleSavedJob
            }
          )
        }
      )
    ]
  }
);
const JobCardLite = (props) => {
  const { jobUrlOpts, renderRelativePaths, isLoggedIn } = useJobDetailsViewContext();
  const { id, [JOB_LISTING_POSITION_KEY]: pos, solHash } = props;
  const url = useJobUrl({
    id,
    jobUrlOpts: {
      ...jobUrlOpts,
      params: {
        ...jobUrlOpts == null ? void 0 : jobUrlOpts.params,
        // Should ignore the `sp` param for competitive recommended jobs
        [JOB_LISTING_NUMBER_OF_SELLING_POINT_KEY]: void 0,
        [JOB_LISTING_POSITION_KEY]: pos
      },
      meta: { solMetadataReference: solHash }
    },
    renderRelativePaths,
    overrideValues: {
      ref: "cp-recs",
      origin: jobUrlOriginValues.competitiveRecommendedJobs
    },
    isExpired: false
  });
  return /* @__PURE__ */ jsx(JobCardLiteView, { ...props, jobUrl: url, isLoggedIn });
};
export {
  JOB_DISPLAY_TYPE_QUERY_KEY,
  JOB_LISTING_NUMBER_OF_SELLING_POINT_KEY,
  JOB_LISTING_POSITION_KEY,
  JobCardLite,
  jobUrlOriginValues,
  useJobUrl
};
